import { render, staticRenderFns } from "./EditTextTextoConfig.vue?vue&type=template&id=206cad71&scoped=true"
import script from "./EditTextTextoConfig.vue?vue&type=script&lang=js"
export * from "./EditTextTextoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cad71",
  null
  
)

export default component.exports